import React from "react";
import AadhaarDigilocker from "../../../Components/AadhaarDigilocker";
import { useAuth } from "../../../Contexts/AuthenticateProvider";

// Same DigiLocker flow as the customer app: the widget opens on this page and the Aadhaar
// data is fetched as soon as the customer completes it (see Components/AadhaarDigilocker).
const AadhaarStage = ({ customerDetails, onVerified }) => {
    const { hasPermission } = useAuth();
    const canSubmit = hasPermission("customer.kyc.aadhaar.submit");
    const customerId = customerDetails?.customerId;
    return (
        <AadhaarDigilocker
            initialAadhaarNo={customerDetails?.kyc?.aadhaar?.aadhaarNo}
            status={customerDetails?.kycStatus?.aadhaar?.status || customerDetails?.kyc?.aadhaar?.status}
            linkUrl={`/staff/customer/${customerId}/kyc/aadhaar/link`}
            verifyUrl={`/staff/customer/${customerId}/kyc/aadhaar/verify`}
            canSubmit={canSubmit}
            onVerified={onVerified}
        />
    );
};

export default AadhaarStage;
